import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "customDatePipe",
    standalone: true
})
export class CustomDatePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (value === 0 || value === " " || value == null) {
      return null;
    }

    return new Date(value);
  }
}
